import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";

const StateLabel = ({ state }) => {
  const stateConfig = {
    VALIDATED: {
      text: "ACCETTATO",
      textClass: "text-success",
      iconClass: "icon-success",
      icon: "it-check-circle",
    },
    LOADED: {
      text: "DA VERIFICARE",
      textClass: "text-warning",
      iconClass: "icon-warning",
      icon: "it-close-circle",
    },
    REFUSED: {
      text: "RIFIUTATO",
      textClass: "text-danger",
      iconClass: "icon-danger",
      icon: "it-close-circle",
    },
  };

  // Usa la configurazione se esiste, altrimenti stato generico
  const { text, textClass, iconClass, icon } = stateConfig[state] || {
    text: state,
    textClass: "text-secondary",
    iconClass: "icon-secondary",
    icon: "it-close-circle",
  };

  return (
    <b className={textClass} title={text}>
      <svg className={`icon align-middle ${iconClass}`} aria-label={text}>
        <use href={`${iconSprite}#${icon}`} />
      </svg>{" "}
      
    </b>
  );
};

export default StateLabel;